<template>
  <admin-layout
    :title="candidate.name"
    menu="Candidatos"
  >
    <div class="row">
      <div class="col-lg-9 col-xs-12">
        <Header
          :candidate="candidate"
          :applies="applies"
          :apply="apply"
          :skills="skills"
          :other_avatar="other_avatar"
        />
        <div class="space-candidate-layout mt-3 mb-3"></div>
        <div class="border-dark-purple">
          <div
            @click="showBigfive"
            class="pointer p-2"
          >
            <span class="f12 pointer">
              <i class="fas mr-2 fa-address-book color-purple mr-1"></i>
              BIGFIVE COMPLETO
            </span>
          </div>
          <BigfiveShow
            v-if="candidate.uid"
            :candidate_uid="candidate.uid"
            :no_next="true"
            :only_graph="true"
          />
        </div>
        <div class="space-candidate-layout mt-3 mb-3"></div>
        <Experiences
          :candidate_id="candidate.id"
          :recruiter_id="recruiter_id"
        />
        <div class="space-candidate-layout mt-3 mb-3"></div>
        <Education :candidate_id="candidate.id" />
        <div class="space-candidate-layout mt-3 mb-3"></div>
        <Language :candidate_id="candidate.id" />
      </div>
      <div class="col-lg-3 col-xs-12">
        <Interview class="hide" /> <!-- commented because it does not work yet -->
        <DataCandidate
          :candidate_id="candidate.id"
          :candidate="candidate"
        />
        <Applies :talent_banks_id="candidate.talent_banks_id" :candidates="[candidate]" />
        <Comments :candidate_id="candidate.id" />
        <Notes :candidate_id="candidate.id" />
        <Files :candidate="candidate" />
      </div>
    </div>
  </admin-layout>
</template>

<script>
import Header from "@/Recruiters/TalentBank/Candidates/Header.vue";
import Experiences from "../Experiences/Index.vue";
import Education from "../Educations/Index.vue";
import Language from "../Languages/Index.vue";
import Interview from "../Interviews/Index.vue";
import Applies from "./AllApplies.vue";
import Comments from "../Comments/Index.vue";
import Notes from "../Notes/Index.vue";
import Files from "../Files/Index.vue";
import DataCandidate from "../DataCandidate/Index.vue";
import BigfiveShow from "@/Bigfives/Show.vue";

export default {
  props: [
    "candidate",
    "apply",
    "applies",
    "recruiter_id",
    "skills",
    "other_avatar",
  ],
  components: {
    Header,
    Experiences,
    Education,
    Language,
    Interview,
    Applies,
    Comments,
    Notes,
    Files,
    DataCandidate,
    BigfiveShow,
  },
  methods: {
    showBigfive() {
      this.$modal.show(
        BigfiveShow,
        {
          candidate_uid: this.candidate.uid,
          no_next: true,
          only_graph: false,
        },
        {
          width: "60%",
          height: "auto",
          scrollable: true,
        }
      );
    },
  },
};
</script>
